import { useCallback } from 'react';

import { useGraphql } from '../graphql';

// Saves the given profile fields and leaves the others as they are. Every
// onboarding step saves through this, each with its own fields.
export function useUpdateProfile() {
  const graphql = useGraphql();

  return useCallback(function(input) {
    return graphql({
      document: `mutation UpdateProfile($input: ProfileInput!) {
        updateProfile(input: $input) { id onboardingStep }
      }`,
      variables: { input }
    });
  }, [ graphql ]);
}
